export default __webpack_public_path__ + "static/bbqg_hero_background_optimised-de9cc179420675f4539e58726be58c47.png";